module.exports = __webpack_public_path__ + "img/070a7f603faf428e44d61239052c907f.png";